export enum ApiTag {
	Tenant = "tenant",
	Audit = "audit",
	Bridge = "bridge",
	MedicalHierarchy = "medicalhierarchy",
	Integrations = "integrations",
	IntegrationsGenesisCare	= "integrations/genesiscare",
	IntegrationsSpire = "integrations/spire",
	Patient = "patient",
	PatientCondition = "patientcondition",
	Phin = "phin",
	Professional = "professional",
	Sso = "sso",
	Template = "template"
}
